export const COLORS = {
  buttonActive: "#53AEF4",
  buttonInactive: "#A8C6DD",
  buttonActiveHover: "#3A96DB",
};
